export default class ModalListDuplicateDocumentController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {string} name
	 */
	constructor($uibModalInstance, name) {
		this.$uibModalInstance = $uibModalInstance;
		this.name = name;
	}

	cancel() {
		return this.$uibModalInstance.dismiss();
	}

	submit() {
		return this.$uibModalInstance.close(this.name);
	}
}
